import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class AdresseService {
  constructor(private httpClient: HttpClient) {}

  getData() {
    return this.httpClient.get(environment.Localurl + "adresse");
  }

  insertData(data) {
    return this.httpClient.post(environment.Localurl + "adresse", data);
  }

  deleteData(id) {
    return this.httpClient.delete(environment.Localurl + "adresse/" + id);
  }

  getOneData(id) {
    return this.httpClient.get(environment.Localurl + "adresse/" + id);
  }

  updateData(id, data) {
    return this.httpClient.put(environment.Localurl + "adresse/" + id, data);
  }
  getAllAdresseByClient(id) {
    return this.httpClient.get(
      environment.Localurl + "adresse/findadressebyIdclient/" + id
    );
  }
}
